import { render, staticRenderFns } from "./source-item.vue?vue&type=template&id=2c5ef89e&scoped=true&"
import script from "./source-item.vue?vue&type=script&lang=js&"
export * from "./source-item.vue?vue&type=script&lang=js&"
import style0 from "./source-item.vue?vue&type=style&index=0&id=2c5ef89e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ef89e",
  null
  
)

export default component.exports